import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import { getStyle } from './utils.es.js';
import { PATTERN_VALIDATION } from '@teko-builder/utils';

const InputV1 = (props) => {
    const { commonStyle, inputStyle, placeholder, type, register, name, id } = props, rest = __rest(props, ["commonStyle", "inputStyle", "placeholder", "type", "register", "name", "id"]);
    const getPattern = (type) => {
        if (type === 'email')
            return PATTERN_VALIDATION.email;
        if (type === 'tel')
            return PATTERN_VALIDATION.phone;
    };
    return (jsx(Wrapper, Object.assign({ commonStyle: commonStyle, id: id }, { children: jsx(StyledInput, Object.assign({ inputStyle: inputStyle, placeholder: placeholder, type: type }, (register
            ? register(name, Object.assign({ pattern: getPattern(type) }, rest))
            : Object.assign({ name }, rest)))) })));
};
const Wrapper = styled.div(({ commonStyle }) => `
  border-style: solid;
  border-color: rgb(238, 238, 238);
  border-width: 1px;
  overflow: hidden;
  ${getStyle(commonStyle)}
`);
const StyledInput = styled.input(({ inputStyle }) => `
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 100%;
    color: rgba(0, 0, 0, 0.85);
    height: 100%;
    padding: 0 0.5rem;
    &:focus,
    &-focused {
      outline: 0;
    }
    &::-moz-placeholder {
      opacity: 1;
    }

    &::placeholder {
      color: #999;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
    &,
    &:hover,
    &:focus,
    &-focused,
    &-disabled,
    &[disabled] {
      border: none;
      box-shadow: none;
    }
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    &[type='number'] {
      -moz-appearance: textfield;
    }
  ${getStyle(inputStyle)}
`);
InputV1.displayName = 'InputV1';

export { InputV1 as I };
